import { IBieuMauNguoiDungActionTypes } from "../../action-types/quan-ly-bieu-mau/IBieuMauNguoiDungActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IBieuMauNguoiDungReducer } from "./IBieuMauNguoiDungReducer";

const iniState : IBieuMauNguoiDungReducer = {
    status: eReducerStatusBase.is_not_initialization,
    bieuMauNguoiDungs: [],
    isShowEditModal: false,
    bieuMauNguoiDungEdit: undefined,
    fieldsByChucNang: [],
};

export const bieuMauNguoiDungReducer = (state: IBieuMauNguoiDungReducer = iniState, action: IBieuMauNguoiDungActionTypes): IBieuMauNguoiDungReducer => {
    switch (action.type) {
        case "BIEU_MAU_NGUOI_DUNG_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "BIEU_MAU_NGUOI_DUNG_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                bieuMauNguoiDungs: action.payload,
            };
        case "BIEU_MAU_NGUOI_DUNG_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "BIEU_MAU_NGUOI_DUNG_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "BIEU_MAU_NGUOI_DUNG_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "BIEU_MAU_NGUOI_DUNG_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "BIEU_MAU_NGUOI_DUNG_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "BIEU_MAU_NGUOI_DUNG_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "BIEU_MAU_NGUOI_DUNG_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "BIEU_MAU_NGUOI_DUNG_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                bieuMauNguoiDungEdit: action.payload
            };
        case "BIEU_MAU_NGUOI_DUNG_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false
            };
        case "BIEU_MAU_NGUOI_DUNG_LOAD_FIELDS_BY_CHUC_NANG_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "BIEU_MAU_NGUOI_DUNG_LOAD_FIELDS_BY_CHUC_NANG_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                fieldsByChucNang: action.payload,
            };
        case "BIEU_MAU_NGUOI_DUNG_LOAD_FIELDS_BY_CHUC_NANG_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}